<template>
	<div class="doc-basic-info">
		<doc-basic-info-card
			:card-title="'基本信息'"
			:edit-label="'编辑基本信息'"
			:info="basicCardLayout"
			@edit="onEdit"
			:can-edit="canEdit"
			:loading="loading"
		></doc-basic-info-card>
		<a-card title="关联合同" :bordered="false" class="relative-doc-card" :loading="loading">
			<div class="relative-doc-sn">
				关联合同编号:
				<span
					v-for="(item,index) in docBasicInfo.contract_list"
					:key="index"
					@click="toRelative(item)"
				>{{item.contract_sn}}</span>
			</div>
		</a-card>
		<!-- <a-card
			title="关联报价"
			:bordered="false"
			class="relative-doc-card"
			:loading="loading"
			v-if="basicInfoProps.contract_type != 6"
		>
			<a href="javascript:;" slot="extra" v-if="canEdit" @click="showRelevanceModal = true">+ 关联报价</a>
			<a-table
				:indentSize="0"
				:locale="locale"
				:rowKey="record => record.bid_id"
				:columns="columns"
				:dataSource="dataSource"
				:pagination="false"
				:loading="loading"
			>
				<template slot="tdHasTooltip" slot-scope="text, record" v-if="record.bid_id">
					<div class="commonCell">
						<span>{{text}}</span>
					</div>
				</template>
				<span slot="operation" slot-scope="text, record" v-if="record.bid_id">
					<template>
						<a-popconfirm
							class="doc-delete"
							title="确定要删除此关联吗?"
							@confirm="confirm"
							@cancel="cancel"
							okText="确认"
							cancelText="取消"
						>
							<a
								href="javascript:;"
								v-if="canEdit"
								@click="toDelete(record)"
								style="margin-right: 24px;"
							>删除</a>
						</a-popconfirm>
					</template>
					<a @click="toDetail(record)">查看详情</a>
				</span>
			</a-table>
		</a-card> -->
		<a-modal title="编辑合同" v-model="showCreateModal" :maskClosable="false" width="640px">
			<create-doc-form
				ref="editForm"
				v-if="fieldOpts.length && showCreateModal"
				:init-data="initData"
				:form-types="fieldOpts"
				@change="createDocChange"
			></create-doc-form>
			<template slot="footer">
				<a-button @click="handleCancel">取消</a-button>
				<a-button type="primary" :loading="submitLoading" @click="handleCreateOk">提交</a-button>
			</template>
		</a-modal>
		<a-modal title="关联报价" v-model="showRelevanceModal" :maskClosable="false" width="640px">
			<div class="relevance">
				<doc-relevance-modal v-if="showRelevanceModal" @dataSource="getDataSource"></doc-relevance-modal>
			</div>
			<template slot="footer">
				<a-button @click="handleCancel">取消</a-button>
				<a-button type="primary" :disabled="modalDisabled" :loading="relevanceLoading" @click="handleRelevanceOk">关联</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import _ ,{debounce} from "lodash";

import { getCustomerOpts } from './common';

import moment from "moment";
import {
  getContract,
  initDocOptions,
  modifyContract,
  docService
} from "../../services/DocService.js";

export default {
  props: {
    basicInfoProps: Object,
    canEdit: Boolean,
    stepInfo: Object
  },
  data() {
    return {
      showCreateModal: false,
      showRelevanceModal: false,
      loading: false,
      fieldOpts: [],
      docBasicInfo: {},
      initData: {},
      columns: [
        {
          title: "报价编号",
          dataIndex: "bid_sn",
          // fixed: "left",
          width: 200,
          align: "left",
          scopedSlots: { customRender: "tdHasTooltip" }
        },
        {
          title: "创建人",
          width: 200,
          dataIndex: "creator",
          scopedSlots: { customRender: "tdHasTooltip" }
        },
        {
          title: "报价创建时间",
          dataIndex: "create_time",
          scopedSlots: { customRender: "tdHasTooltip" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          align: "left",
          width: 300,
          scopedSlots: { customRender: "operation" }
        }
      ],
      dataSource: null,
      dataBasic: {}, // 搜索结果
      locale: {
        emptyText: "暂无数据"
      },
      modalDisabled: true,
      target_bid_id: 0, //待删除目标id
      submitLoading: false,
      relevanceLoading: false,
    };
  },

  computed: {
    basicCardData() {
      const field_label = this.docBasicInfo.field_label;
      const contract_info = this.docBasicInfo.contract_info;
      const infos = [];
      if (field_label) {
        field_label.forEach((item, index) => {
          if (
            _.isObject(contract_info[item.field]) &&
            contract_info[item.field]
          ) {
            infos.push({
              label: item.label,
              key: item.field,
              value: contract_info[item.field].name
            });
          } else if (!_.isObject(contract_info[item.field])) {
            infos.push({
              label: item.label,
              key: item.field,
              value: contract_info[item.field]
            });
          }
        });
        const infoGroups = [];
        for (let i = 1; i <= Math.ceil(infos.length / 6); i += 1) {
          const item = infos.slice((i - 1) * 6, (i - 1) * 6 + 6);
          infoGroups.push(item);
        }
        return infoGroups;
      }
    },
    basicCardLayout() {
      return [
        {
          hasTitle: false,
          data: this.basicCardData
        }
      ];
    },
    loaded() {
      if (this.fieldOpts.length > 0 && Object.keys(this.initData).length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    fetchContractInfo() {
      this.loading = true;
      getContract({
        contract_id: this.basicInfoProps.contract_id,
        step_num: this.stepInfo.stepKey
      }).then(res => {
        if (res.status === "success") {
          this.docBasicInfo = res.data;
          this.initData = _.cloneDeep(res.data.contract_info);
          for (let key in this.initData) {
            if (_.isObject(this.initData[key])) {
              if (key === "customer_name") {
                this.initData[key] =
                  this.initData[key].id + "_" + this.initData[key].name;
              } else {
                this.initData[key] = this.initData[key].id;
              }
            }
          }
          this.initDataBackup = _.cloneDeep(this.initData);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },
    onEdit(e) {
      this.initData = _.cloneDeep(this.initDataBackup);
      this.showCreateModal = true;
    },
    // 选项
    createDocChange(val) {
      let keys = Object.keys(val);
      if (!keys.length) {
        return;
      }
      let name = keys[0];
      if (name === "archival_status") {
        initDocOptions({
          contract_type: this.basicInfoProps.contract_type,
          archival_status: val[name].value,
          step_num: this.stepInfo.stepKey,
          new: 1
        }).then(res => {
          if (res.status === "success") {
            this.fieldOpts = res.data.field_options;
            this.fieldOptsBackupFaker = _.cloneDeep(res.data.field_options);
            this.initFieldOpts(this.fieldOpts);
            if (this.$refs.editForm) {
              this.$refs.editForm.createForm();
            }
          } else {
            this.$Message.error(res.message);
          }
        });
      }
      const currFiledObj = this.fieldOpts.find(item => {
        return item.field === name;
      });
      if (moment.isMoment(val[name].value)) {
        if (currFiledObj.tpl === "month") {
          val[name].value = moment(val[name].value).format("YYYY-MM");
        } else {
          val[name].value = moment(val[name].value).format("YYYY-MM-DD");
        }
      }
      if (name === "customer_name" && val[name].value) {
        this.initData[name] = val[name].value;
      } else {
        this.initData[name] = val[name].value;
      }
      if (currFiledObj.target && currFiledObj.target !== "") {
        this.getTarget(currFiledObj.target, val[name].value);
      }
    },
getOpts:debounce((params,item)=>{
  getCustomerOpts(params).then(res => {
    item.options = res.data
            })
},500)
,
    getTarget(targetField, parentVal) {
      this.fieldOpts = _.cloneDeep(this.fieldOptsBackupFaker || this.fieldOpts);
      this.fieldOpts.forEach(item => {
         if (item.field === targetField) {
          if (item.depends && item.depends.length) {
            const params = {}
            item.depends.forEach(dep => {
              params[dep] = this.initData[dep]
            })
          
          this.getOpts(params,item)
          } else {

            item.options = item.options.filter(
              option => Number(option.parent_id) === parentVal
            );
          }

        }
      });
    },
    handleCancel() {
      this.showCreateModal = false;
      this.showRelevanceModal = false;
    },
    handleCreateOk() {
      this.$refs.editForm.form.validateFields((err, fieldsValue) => {
        if (err) {
          return;
        }
        if (
          this.initData.customer_name &&
          this.initData.customer_name.indexOf("_") > -1
        ) {
          this.initData.customer_name = this.initData.customer_name.split(
            "_"
          )[0];
        }
        this.submitLoading = true;
        modifyContract({
          contrat_data: this.initData,
          step_num: this.stepInfo.stepKey
        }).then(res => {
          if (res.status === "success") {
            this.fetchContractInfo();
            this.$emit("update-doc");
            this.showCreateModal = false;
            if (this.fieldOptsBackupFaker) {
              this.fieldOptsBackup = this.fieldOptsBackupFaker;
            }
          } else {
            this.$Message.error(res.message);
            // this.showCreateModal = false;
          }
          this.submitLoading = false;
        });
      });
    },
    fetchFieldOpts() {
      return initDocOptions({
        contract_type: this.basicInfoProps.contract_type,
        archival_status: this.basicInfoProps.archival_status,
        step_num: this.stepInfo.stepKey,
        new: 0
      }).then(res => {
        if (res.status === "success") {
          res.data.field_options.forEach(item => {
            if (item.field === "customer_name") {
              item.options.map(op => {
                op.option_id = op.option_id + "_" + op.option_name;
              });
            }
          });
          this.fieldOpts = res.data.field_options;
          this.fieldOptsBackup = _.cloneDeep(res.data.field_options);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    initFieldOpts(backup) {
      this.fieldOpts = _.cloneDeep(backup);
      this.fieldOpts.forEach(item => {
        if (item.target && item.target !== "" && this.initData[item.field]) {
          let targetObj = this.fieldOpts.find(child => {
            return child.field === item.target;
          });
          targetObj.options = targetObj.options.filter(
            option => Number(option.parent_id) === this.initData[item.field]
          );
        }

if ( item.depends&& item.depends.length) {
   const params = {}
            item.depends.forEach(dep => {
              params[dep] = this.initData[dep]
            })
          
          this.getOpts(params,item)

  console.log(item);
}
      });
    },
    toRelative(code) {
      this.$emit("refresh", code.contract_id);
    },
    // 删除已关联的报价
    toDelete(e) {
      this.target_bid_id = e.bid_id;
    },

    // 前往已关联的报价
    toDetail(e) {
      const url = `${window.location.origin}/price/list/${
        e.bid_id
      }/info2?canEdit=${this.canEdit}`;
      window.open(url, "_blank");
    },

    // 确认删除回调函数
    confirm() {
      docService
        .setBidDelete({
          contract_sn: this.basicInfoProps.contract_sn,
          bid_id: this.target_bid_id
        })
        .then(res => {
          if (res.status == "success") {
            this.$Message.success("删除成功!");
            // this.getBidList();
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(rej => {
          this.$Message.error(rej.message);
        });
    },

    // 取消删除回调函数
    cancel(e) {},

    // 关联
    handleRelevanceOk() {
      this.relevanceLoading = true;
      docService
        .setBidAdd({
          contract_sn: this.basicInfoProps.contract_sn,
          bid_id: this.dataBasic.bid_id
        })
        .then(res => {
          if (res.status == "success") {
            this.$Message.success("关联成功!");
            this.showRelevanceModal = false;
            // this.getBidList();
          } else {
            this.$Message.error(res.message);
          }
          this.relevanceLoading = false;
        })
        .catch(rej => {
          this.relevanceLoading = false;
          this.$Message.error(rej.message);
        });
    },

    // 关联列表
    // getBidList() {
    //   docService
    //     .getBidList({ contract_id: this.basicInfoProps.contract_id })
    //     .then(res => {
    //       if (res.status == "success") {
    //         this.dataSource = res.data;
    //       }
    //     })
    //     .catch(rej => {});
    // },

    // 搜索结果
    getDataSource(e) {
      this.dataBasic = e;
      if (e && e.bid_id) {
        this.modalDisabled = false;
      } else {
        this.modalDisabled = true;
      }
    }
  },

  mounted() {
    this.fetchFieldOpts();
    this.fetchContractInfo();
    // this.getBidList();
  },
  watch: {
    loaded(val) {
      if (val) {
        this.initFieldOpts(this.fieldOptsBackup);
      }
    },
    initData() {
      if (this.loaded) {
        this.initFieldOpts(this.fieldOptsBackup);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.relative-doc-card {
  margin-top: 16px;
  .ant-card-body {
    padding: 24px;
  }
  .relative-doc-sn {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 22px;
    span {
      color: #0295ee;
      margin-right: 32px;
      cursor: pointer;
    }
    span:first-child {
      margin-left: 8px;
    }
  }
}
</style>
<style lang="less">
.doc-delete {
  .ant-popover-inner-content {
    .ant-popover-buttons {
      .ant-btn-sm {
        font-size: 8px;
      }
    }
  }
}
</style>
